<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="4">
          <v-text-field
            label="NAS-ID"
            v-model="nasIdentifierFilter"
            @keydown="() => clearTypingTimer(typingTimerIdNasIdentifier)"
            @keyup="triggerTypingTimerIdNasIdentifier"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            label="Ip Publique"
            v-model="publicIpFilter"
            @keydown="() => clearTypingTimer(typingTimerIdPublicIp)"
            @keyup="triggerTypingTimerPublicIp"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-menu
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="lastAuthAtFilter"
                label="Dernière requête depuis le"
                persistent-hint
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="datepicked" no-title></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { defineComponent, ref, watch } from "@vue/composition-api";
import { DateTime } from "luxon";

export default defineComponent({
  props: {
    criteria: Object,
  },
  setup(props, { emit }) {
    /* Variables */
    const nasIdentifierFilter = ref(props.criteria.nasIdentifier);
    const publicIpFilter = ref(props.criteria.ipPub);
    const lastAuthAtFilter = ref(props.criteria.lastAuthAt);
    const datepicked = ref("");
    let typingTimerIdNasIdentifier = 0;
    let typingTimerIdPublicIp = 0;
    const debounceInterval = 500;

    /* Méthodes */
    const triggerTypingTimerIdNasIdentifier = function () {
      clearTimeout(typingTimerIdNasIdentifier);
      typingTimerIdNasIdentifier = setTimeout(function () {
        const terms = nasIdentifierFilter.value;
        const proxy = { ...props.criteria };
        proxy.nasIdentifier = terms;
        emit("update:criteria", proxy);
      }, debounceInterval);
    };
    const triggerTypingTimerPublicIp = function () {
      clearTimeout(typingTimerIdPublicIp);
      typingTimerIdPublicIp = setTimeout(function () {
        const terms = publicIpFilter.value;
        const proxy = { ...props.criteria };
        proxy.ipPub = terms;
        emit("update:criteria", proxy);
      }, debounceInterval);
    };
    const clearTypingTimer = function (timerId) {
      clearTimeout(timerId);
    };

    /* Watchers */
    watch(
      () => datepicked.value,
      function (newValue) {
        if (newValue != "") {
          lastAuthAtFilter.value = DateTime.fromISO(String(newValue)).toFormat(
            " yyyy-LL-dd"
          );
        } else {
          lastAuthAtFilter.value = "";
        }

        const proxy = { ...props.criteria };
        proxy.lastAuthAt = lastAuthAtFilter.value;
        emit("update:criteria", proxy);
      }
    );

    return {
      nasIdentifierFilter,
      publicIpFilter,
      lastAuthAtFilter,
      datepicked,
      triggerTypingTimerIdNasIdentifier,
      triggerTypingTimerPublicIp,
      clearTypingTimer,
    };
  },
});
</script>
